import styled from '@emotion/styled';

export const Card = styled.button`
  width: 100%;
  opacity: ${({ notSelected }) => (notSelected ? '0.7' : '1')};
  background: ${({ theme, color }) => theme.colors[color]};
  border: ${({ theme, selected }) =>
    selected ? theme.borders.emphasis : theme.borders.primary};
  border-color: ${({ color, theme }) => theme.colors[color]};
  margin-bottom: ${({ theme }) => theme.spacings[5]};
  margin-left: 0;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};

  padding: 0;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.header`
  display: flex;
  padding: 1rem 3rem 1.5rem 1.5rem;
  text-align: left;
`;

export const Inner = styled.div`
  background: ${({ theme, selected, i }) =>
    selected
      ? i % 2
        ? theme.colors.lighterPurple
        : theme.colors.liteBlue
      : theme.colors.white};
  padding: 1rem 2rem 1rem 1.5rem;
  text-align: left;
  height: 100%;
  width: 100%;
`;
